export default "__VITE_ASSET__053d3665__"